export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher un utilisateur par nom ou email..."])},
        "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun utilisateur"])},
        "column_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id"])},
        "column_email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "column_full_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "column_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôle"])},
        "column_signed_up": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inscrit"])},
        "role_admin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
        "role_sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animateur"])},
        "signed_up_yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui"])},
        "signed_up_no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search a user by name or email..."])},
        "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No user"])},
        "column_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id"])},
        "column_email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "column_full_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "column_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role"])},
        "column_signed_up": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Signed up"])},
        "role_admin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
        "role_sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales field manager"])},
        "signed_up_yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
        "signed_up_no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No"])}
      }
    }
  })
}
